<template>
  <p
    v-if="views && material.viewsCount"
    class="material__statistic_item"
  >
    <img
      src="../../../assets/images/i-views.svg"
      alt="просмотры"
    >
    <span>{{ material.viewsCount }}</span>
  </p>
  <p
    v-else-if="likes && material.likesCount"
    class="material__statistic_item"
  >
    <img
      src="../../../assets/images/i-like.svg"
      alt="лайки"
    >
    <span>{{ material.likesCount }}</span>
  </p>
</template>

<script>
export default {
  name: 'MaterialStatistic',
  props: {
    material: { type: Object, required: true },
    views: { type: Boolean, default: false },
    likes: { type: Boolean, default: false },
  },
};
</script>

<style scoped lang="scss">

.material__statistic_item {
  display: flex;
  align-items: center;
  gap: calc(var(--scale) * 2);

  img {
    width: calc(var(--scale) * 24);
  }

  span {
    font-weight: 500;
    font-size: calc(var(--scale) * 14);
    line-height: 130%;
    color: #A7ABAC;
  }
}

</style>
